import React from "react";
import { Button } from "reactstrap";

interface StepLayoutProps {
  title: string;
  description?: string;
  onBack: () => void;
  onNext: () => void;
  disableBack?: boolean;
  disableNext?: boolean;
  isNextLoading?: boolean;
  nextLabel?: string;
  loadingLabel?: string;
  extraControls?: React.ReactNode;
  children: React.ReactNode;
}

const StepLayout = ({
  title,
  description,
  onBack,
  onNext,
  disableBack,
  disableNext,
  isNextLoading,
  nextLabel = "Siguiente",
  loadingLabel = "Guardando...",
  extraControls,
  children,
}: StepLayoutProps) => (
  <>
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
      <div>
        <h5 className="mb-1">{title}</h5>
        {description && <p className="text-muted mb-0">{description}</p>}
      </div>
      <div className="d-flex gap-2 align-items-center">
        <Button color="light" onClick={onBack} disabled={disableBack}>
          Volver
        </Button>
        <Button color="primary" onClick={onNext} disabled={disableNext}>
          {isNextLoading ? loadingLabel : nextLabel}
        </Button>
        {extraControls}
      </div>
    </div>
    {children}
  </>
);

export default StepLayout;
